import { IonContent, IonPage, IonRefresher, IonRefresherContent } from '@ionic/react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { customerBackend, customerFrontend } from '../apiConfig'
import DummyHeader from '../components/DummyHeader'
import sendToIframe from '../sendToIframe'
import { selectCustomer, selectSession } from '../store'

const iframeTitle = 'deliveries'

const iframeSrc = `${customerFrontend}?${iframeTitle}`

export default function Deliveries() {
  const { authToken } = useSelector(selectSession)
  const customer = useSelector(selectCustomer)

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      try {
        const { name, route } = JSON.parse(event.data)

        if (!route.includes(iframeTitle)) return

        if (name === 'loaded' && authToken) {
          sendToIframe(
            {
              name: 'customer',
              authToken,
              backendUrl: customerBackend,
              locks: customer?.allAccesses.filter((l) => l.sub_type === 'container' && !l.custom_name.includes('transportörsdörr')),
            },
            iframeTitle
          )
        }
      } catch {
        // ignore
      }
    }

    window.addEventListener('message', handler)

    return () => window.removeEventListener('message', handler)
  }, [authToken])

  return (
    <IonPage>
      <DummyHeader />
      <IonContent>
        <IonRefresher
          slot="fixed"
          onIonRefresh={(e) => {
            setTimeout(() => {
              e.detail.complete()
            }, 1000)
          }}
        >
          <IonRefresherContent />
        </IonRefresher>
        <iframe title={iframeTitle} src={iframeSrc} width="100%" height="100%" allowFullScreen />
      </IonContent>
    </IonPage>
  )
}
